import styled from "styled-components";
import {MainWrapperDefaultBox} from "./main-wrapper.default.box";
import {Color} from "../../../themes/definitions/casino777/casino777-colors";

export const MainWrapperCasino777Box = styled(MainWrapperDefaultBox)`
  background: ${props => `linear-gradient(${Color.lightTeal}, ${props.theme.colors.brandPrimary}, ${Color.lightTeal})`};
`;